import ReviewsMetrics from "./ReviewsMetrics";

export default ReviewsMetrics;
